"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLoggedIn = isLoggedIn;
exports.isLoggedInStrict = isLoggedInStrict;
exports.attachAuthorization = attachAuthorization;
exports.onUnauthorizedError = onUnauthorizedError;
exports.clearLoginStatus = clearLoginStatus;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _token = require("./util/token");

var _api = require("./api");

var _UnauthorizedSsoException = _interopRequireDefault(require("./util/errors/UnauthorizedSsoException"));

var _CustomSsoException = _interopRequireDefault(require("./util/errors/CustomSsoException"));

var _util = require("./util/util");

var _SsoException = _interopRequireDefault(require("./util/errors/SsoException"));

var _host = require("./util/host");

var _router = require("./util/router");

var _config = require("./config");

// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle

/**
 * 判断用户是否已经登录
 *
 * @returns {boolean}
 */
function isLoggedIn() {
  return !!(0, _token.getRefreshToken)();
}
/**
 * 检查 token 是否有效
 *
 * @returns {Promise<boolean>}
 */


function checkToken() {
  return _checkToken.apply(this, arguments);
}
/**
 * 刷新 token
 *
 * @returns {Promise<string|undefined>}
 */


function _checkToken() {
  _checkToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var accessToken, _yield$checkTokenApi, _yield$checkTokenApi$, active;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isLoggedIn()) {
              _context.next = 2;
              break;
            }

            throw new _UnauthorizedSsoException.default('用户尚未登录');

          case 2:
            _context.prev = 2;
            // 检查 token
            accessToken = (0, _token.getAccessToken)();

            if (accessToken) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", false);

          case 6:
            _context.next = 8;
            return (0, _api.checkTokenApi)({
              token: accessToken
            });

          case 8:
            _yield$checkTokenApi = _context.sent;
            _yield$checkTokenApi$ = _yield$checkTokenApi.active;
            active = _yield$checkTokenApi$ === void 0 ? false : _yield$checkTokenApi$;
            return _context.abrupt("return", active);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);

            if (!(_context.t0 instanceof _SsoException.default)) {
              _context.next = 18;
              break;
            }

            throw _context.t0;

          case 18:
            if (!(0, _util.isAccessTokenExpired)(_context.t0)) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return", false);

          case 20:
            throw new _CustomSsoException.default((0, _util.getApiErrorMessage)(_context.t0));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 14]]);
  }));
  return _checkToken.apply(this, arguments);
}

function refreshToken() {
  return _refreshToken.apply(this, arguments);
}
/**
 * 联网判断用户是否登录
 *
 * @returns {Promise<boolean>}
 */


function _refreshToken() {
  _refreshToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _yield$refreshTokenAp, accessToken, newRefreshToken, expiresIn;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (isLoggedIn()) {
              _context2.next = 2;
              break;
            }

            throw new _UnauthorizedSsoException.default('用户尚未登录');

          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return (0, _api.refreshTokenApi)({
              grant_type: 'refresh_token',
              refresh_token: (0, _token.getRefreshToken)()
            });

          case 5:
            _yield$refreshTokenAp = _context2.sent;
            accessToken = _yield$refreshTokenAp.access_token;
            newRefreshToken = _yield$refreshTokenAp.refresh_token;
            expiresIn = _yield$refreshTokenAp.expires_in;
            (0, _token.setAccessToken)(accessToken, expiresIn);
            return _context2.abrupt("return", (0, _token.setRefreshToken)(newRefreshToken));

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](2);

            if (!(_context2.t0 instanceof _SsoException.default)) {
              _context2.next = 17;
              break;
            }

            throw _context2.t0;

          case 17:
            if (!(0, _util.isRefreshTokenExpired)(_context2.t0)) {
              _context2.next = 20;
              break;
            }

            // refresh token 过期
            (0, _token.removeRefreshToken)();
            throw new _UnauthorizedSsoException.default('登录信息已经过期');

          case 20:
            throw new _CustomSsoException.default((0, _util.getApiErrorMessage)(_context2.t0));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 13]]);
  }));
  return _refreshToken.apply(this, arguments);
}

function isLoggedInStrict() {
  return _isLoggedInStrict.apply(this, arguments);
}
/**
 * 获取 access token，如果 access token 不存在就去重新获取
 *
 * @returns {Promise<string>}
 */


function _isLoggedInStrict() {
  _isLoggedInStrict = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var accessToken, tokenAvailable;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (isLoggedIn()) {
              _context3.next = 2;
              break;
            }

            throw new _UnauthorizedSsoException.default('用户尚未登录');

          case 2:
            _context3.prev = 2;
            // 检查 token
            accessToken = (0, _token.getAccessToken)(); // 如果 access token 存在

            if (!accessToken) {
              _context3.next = 10;
              break;
            }

            _context3.next = 7;
            return checkToken();

          case 7:
            tokenAvailable = _context3.sent;

            if (!tokenAvailable) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", true);

          case 10:
            _context3.next = 12;
            return refreshToken();

          case 12:
            return _context3.abrupt("return", !!_context3.sent);

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](2);

            if (!(_context3.t0 instanceof _SsoException.default)) {
              _context3.next = 19;
              break;
            }

            throw _context3.t0;

          case 19:
            throw new _CustomSsoException.default((0, _util.getApiErrorMessage)(_context3.t0));

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 15]]);
  }));
  return _isLoggedInStrict.apply(this, arguments);
}

function getAccessTokenAuto() {
  return _getAccessTokenAuto.apply(this, arguments);
}
/**
 * 为 axios config 增加 token
 * 这里如果报错会被忽略掉，保障请求能够正常执行
 *
 * @param {object} config
 * @returns {Promise<object>}
 */


function _getAccessTokenAuto() {
  _getAccessTokenAuto = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var accessToken;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (isLoggedIn()) {
              _context4.next = 2;
              break;
            }

            throw new _UnauthorizedSsoException.default('用户尚未登录');

          case 2:
            _context4.prev = 2;
            // 检查 token
            accessToken = (0, _token.getAccessToken)(); // 如果 access token 存在

            if (!accessToken) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", accessToken);

          case 6:
            _context4.next = 8;
            return refreshToken();

          case 8:
            return _context4.abrupt("return", (0, _token.getAccessToken)());

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](2);

            if (!(_context4.t0 instanceof _SsoException.default)) {
              _context4.next = 15;
              break;
            }

            throw _context4.t0;

          case 15:
            throw new _CustomSsoException.default((0, _util.getApiErrorMessage)(_context4.t0));

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 11]]);
  }));
  return _getAccessTokenAuto.apply(this, arguments);
}

function attachAuthorization(_x) {
  return _attachAuthorization.apply(this, arguments);
}
/**
 * 对于 401 错误的处理
 *
 * @param {Error} error
 * @param {function} hint
 */


function _attachAuthorization() {
  _attachAuthorization = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(config) {
    var res;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (isLoggedIn()) {
              _context5.next = 3;
              break;
            }

            return _context5.abrupt("return", config);

          case 3:
            if ((0, _util.isTaoZhiCloudApi)(config.baseURL)) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", config);

          case 5:
            res = config;

            if (!res.headers) {
              res.headers = {};
            }

            _context5.t0 = "Bearer ";
            _context5.next = 10;
            return getAccessTokenAuto();

          case 10:
            _context5.t1 = _context5.sent;
            res.headers.Authorization = _context5.t0.concat.call(_context5.t0, _context5.t1);
            return _context5.abrupt("return", res);

          case 15:
            _context5.prev = 15;
            _context5.t2 = _context5["catch"](0);
            console.error(_context5.t2);
            return _context5.abrupt("return", config);

          case 19:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 15]]);
  }));
  return _attachAuthorization.apply(this, arguments);
}

function onUnauthorizedError(_x2, _x3) {
  return _onUnauthorizedError.apply(this, arguments);
}
/**
 * 清除登录状态
 */


function _onUnauthorizedError() {
  _onUnauthorizedError = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(error, hint) {
    var _error$response, _error$response$data, errorText;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _error$response = error.response;
            _error$response = _error$response === void 0 ? {} : _error$response;
            _error$response$data = _error$response.data;
            _error$response$data = _error$response$data === void 0 ? {} : _error$response$data;
            errorText = _error$response$data.error;

            if (!(errorText !== 'invalid_token')) {
              _context6.next = 10;
              break;
            }

            if (errorText === 'unauthorized') {
              hint('请求没有携带token！');
            } else {
              hint('身份认证出错');
            }

            (0, _host.toLoginPage)();
            return _context6.abrupt("return");

          case 10:
            _context6.next = 12;
            return isLoggedInStrict();

          case 12:
            if (!_context6.sent) {
              _context6.next = 15;
              break;
            }

            hint('身份认证出错，请重试');
            return _context6.abrupt("return");

          case 15:
            throw new _UnauthorizedSsoException.default('用户尚未登录');

          case 18:
            _context6.prev = 18;
            _context6.t0 = _context6["catch"](0);

            if (!(_context6.t0 instanceof _UnauthorizedSsoException.default)) {
              _context6.next = 24;
              break;
            }

            if (!((0, _config.getConfig)().routerRef && (0, _router.routerIsProtect)((0, _config.getConfig)().routerRef.currentRoute))) {
              _context6.next = 24;
              break;
            }

            (0, _host.toLoginPage)();
            return _context6.abrupt("return");

          case 24:
            hint(_context6.t0.message);

          case 25:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 18]]);
  }));
  return _onUnauthorizedError.apply(this, arguments);
}

function clearLoginStatus() {
  (0, _token.removeRefreshToken)();
}